var map = {
	"./Chat.js": 100,
	"./Fans.es.js": 101,
	"./Giftbox.es.js": 102,
	"./LSTranslator.es.js": 103,
	"./UserChatController.es.js": 104
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99;


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/widget (\/|\\)(?!_)[\w\.\-\\]+\.js$
// module id = 99
// module chunks = 4